module.exports = __webpack_public_path__ + "img/5-5.979c7f17.svg";